import { CUSTOMER_REQUEST, CREATE_CUSTOMER, GET_CUSTOMERS, UPDATE_CUSTOMER, DELETE_CUSTOMER, CUSTOMER_REQUEST_FAILURE } from '../types';

const initialState = {
  customers: [],
  loading: false,
  error: null,
};

const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMER_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_CUSTOMERS: {
      return {
        ...state,
        customers: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_CUSTOMER:
      return {
        ...state,
        customers: [action.payload, ...state.customers],
        loading: false,
        error: null
      };
    case UPDATE_CUSTOMER:
      const customersData = state.customers.slice(0);
      const uIndex = customersData.findIndex((data) => data.id === action.payload.id);
      customersData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        customers: [ ...customersData ],
        loading: false,
        error: null
      };
    case DELETE_CUSTOMER:
      const customers = state.customers?.slice(0);
      const index = customers.findIndex((data) => data.id === action.id);
      if (index > -1) {
        customers.splice(index, 1);
      }
      return {
        ...state,
        customers: [...customers],
        loading: false,
        error: null
      }
    case CUSTOMER_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default customerReducer;
